
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqXyLUg0T4V3tpU8WDlGDF_453N_45oSPMHG_45fiwp4dYly39QMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/faq.vue?macro=true";
import { default as whyAGVlS_45aGmhJbvUJJJCvcizTzzHyMl_qvV7VbW0Zh14IMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/why.vue?macro=true";
import { default as aboutGwqUAfwNG9VSENzMSofBlVjdstboTVcH9fJmn3LnbbQMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/about.vue?macro=true";
import { default as indexie3bGo70JtvhuL0PQjByTIezVlpBLjQSBMlddXxS1eQMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/index.vue?macro=true";
import { default as termsM_EGJpV1Qvjz3GkDHD6rMWjlJmhN4iMWs8If5UZ_35sMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/terms.vue?macro=true";
import { default as contactmFcoW3g4lfmgm4CAHfcjdpvHbta6TF1ef0yx5t12PGoMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/contact.vue?macro=true";
import { default as imprintkHDGO_O88kLfEfN0fMr0qtZgy5EwD3x9cdLK2vL60xcMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/imprint.vue?macro=true";
import { default as pricingFO90hcRNl_9lWaoepH0DVOLZsk_5DCX8YwIej_IDahkMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/pricing.vue?macro=true";
import { default as privacyvgKQuX5A0kNY5BkFOlTdwm8AvUj1TWsKTDBPBoLxjugMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/privacy.vue?macro=true";
import { default as accountnGSYQRXzSYLtSCR_Z_457CuByUxkkMa_iExfN9lHNvKmUMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/account.vue?macro=true";
import { default as deletedvj8mf_45kgwy7SulJWpKfs8Pvdc_45akwohB_458EXuVAlS4sMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/deleted.vue?macro=true";
import { default as history7MyAk2dqkNjpKRG6fKgh8SE7_Dbs0QvdRw4LWG0Vi1gMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/history.vue?macro=true";
import { default as invoiceNoktPUFw76L9OdHR96mVk51qCaHTt5oyHabtl5Ni7poMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/invoice.vue?macro=true";
import { default as api_45keysWyn9owUW2LPVNDZBb4HUNJw8E7dtbaPduWC43rZxmasMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/api-keys.vue?macro=true";
import { default as subscriptionNTE6ph6JrYRxllcu702slkwUW_KEaFDcHaKppPVcn_45oMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/subscription.vue?macro=true";
import { default as indexayyECckble2MWUmALKVZQFdgi4PUpI2E1m5Y2vjUuPUMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/technologies/index.vue?macro=true";
import { default as _91slug_93VEbN56L685limJp7gjFfM8eSFSXTRYInKzukaEiGuYAMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/technologies/[slug].vue?macro=true";
import { default as payment_45methodsJ_45FbEz_45Dlg60Z3RNhYvdH8noMsyQ3QF_9IJ6Vv_MiEYMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/payment-methods.vue?macro=true";
import { default as index1qxD4JuX934p4s8w30mT90ptv4tiIFEm7GncqOPeduQMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/content/articles/index.vue?macro=true";
import { default as webhook_45endpointspsSeS1ePX1OJ2OC8v2iXpN0gKI2WNuDgZeMVKm9ZIdEMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/webhook-endpoints.vue?macro=true";
import { default as _91slug_93yRgtRk0lcxs3yGMHW_45t3mrB3PvfkaNkc6jNDA8gFSEkMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/analysis/website/[slug].vue?macro=true";
import { default as removeA9hEAVWrZ4F977EcGdQLs8x_45HdfWVbhrXdekbOhAFL4Meta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/analysis/website/remove.vue?macro=true";
import { default as _91slug_93kbT4Ts4DDyp902xcBhdsDz3ok6QwRy0aVS_45hOQVKXpcMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/content/articles/[slug].vue?macro=true";
import { default as awesomeHqSrpAMmls2liJAHB0RSZ0zvvsoVbaRDWMltNVbGDNMMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/insights/websites/awesome.vue?macro=true";
import { default as awesomexGiBqOjwI1ZbPyorRjEDVH2Zgw_po4rK4IsLHrx6diEMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/insights/technologies/awesome.vue?macro=true";
import { default as docspuC2Pd1KexqP_qCGsVW08x8YCFmo0Btr6NBpK4yJZbIMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/products/website-analyzer/docs.vue?macro=true";
import { default as _91slug_93twrU_45ibCfz_45koxzFUhbBZeyWydgnmxhcE8qKKOCsruwMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/technologies/[category]/[slug].vue?macro=true";
import { default as most_45usedM6G4ngnQ_g_wcHSyJL3HlmWjsNjzS_UDYI7XBG6dcqUMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/insights/technologies/most-used.vue?macro=true";
import { default as indexZR2ImPPuLJdqwZqIVA8p518Vui2hOQWJ28KkTlYOdNQMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/products/website-analyzer/index.vue?macro=true";
import { default as top_45tech_45stackek7H5ra57J4OeN2LsQbbu1Ep3mHrX_FZxJtg3qbVGQ8Meta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/insights/websites/top-tech-stack.vue?macro=true";
import { default as lighthousetplvDRt_45pIqaCzsxc8YkSzvZ1cPH9m_QPyV5cQ04FcAMeta } from "/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/analysis/website/reports/lighthouse.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/faq.vue")
  },
  {
    name: "why",
    path: "/why",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/why.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/terms.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/contact.vue")
  },
  {
    name: "imprint",
    path: "/imprint",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/imprint.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/pricing.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/privacy.vue")
  },
  {
    name: "user-account",
    path: "/user/account",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/account.vue")
  },
  {
    name: "user-deleted",
    path: "/user/deleted",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/deleted.vue")
  },
  {
    name: "user-history",
    path: "/user/history",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/history.vue")
  },
  {
    name: "user-invoice",
    path: "/user/invoice",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/invoice.vue")
  },
  {
    name: "user-api-keys",
    path: "/user/api-keys",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/api-keys.vue")
  },
  {
    name: "user-subscription",
    path: "/user/subscription",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/subscription.vue")
  },
  {
    name: "technologies",
    path: "/technologies",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/technologies/index.vue")
  },
  {
    name: "technologies-slug",
    path: "/technologies/:slug()",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/technologies/[slug].vue")
  },
  {
    name: "user-payment-methods",
    path: "/user/payment-methods",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/payment-methods.vue")
  },
  {
    name: "content-articles",
    path: "/content/articles",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/content/articles/index.vue")
  },
  {
    name: "user-webhook-endpoints",
    path: "/user/webhook-endpoints",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/user/webhook-endpoints.vue")
  },
  {
    name: "analysis-website-slug",
    path: "/analysis/website/:slug()",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/analysis/website/[slug].vue")
  },
  {
    name: "analysis-website-remove",
    path: "/analysis/website/remove",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/analysis/website/remove.vue")
  },
  {
    name: "content-articles-slug",
    path: "/content/articles/:slug()",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/content/articles/[slug].vue")
  },
  {
    name: "insights-websites-awesome",
    path: "/insights/websites/awesome",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/insights/websites/awesome.vue")
  },
  {
    name: "insights-technologies-awesome",
    path: "/insights/technologies/awesome",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/insights/technologies/awesome.vue")
  },
  {
    name: "products-website-analyzer-docs",
    path: "/products/website-analyzer/docs",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/products/website-analyzer/docs.vue")
  },
  {
    name: "technologies-category-slug",
    path: "/technologies/:category()/:slug()",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/technologies/[category]/[slug].vue")
  },
  {
    name: "insights-technologies-most-used",
    path: "/insights/technologies/most-used",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/insights/technologies/most-used.vue")
  },
  {
    name: "products-website-analyzer",
    path: "/products/website-analyzer",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/products/website-analyzer/index.vue")
  },
  {
    name: "insights-websites-top-tech-stack",
    path: "/insights/websites/top-tech-stack",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/insights/websites/top-tech-stack.vue")
  },
  {
    name: "analysis-website-reports-lighthouse",
    path: "/analysis/website/reports/lighthouse",
    component: () => import("/Users/mdujmovits/devel/awesometechstack/repos/awesometechstack/run/nuxt-service/pages/analysis/website/reports/lighthouse.vue")
  }
]